import { gql } from "@apollo/client"
import { useMutation, InjectedOptions } from "@oysterhr/core"
import {
  TransitionProvisionedEnrollmentInput,
  TransitionProvisionedEnrollmentPayload,
} from "@oysterhr/schema"

const TransitionProvisionedEnrollmentMutation = gql`
  mutation BenefitsTeamMemberTransitionProvisionedEnrollment(
    $enrollmentId: ID!
    $transitionEvent: BenefitsProvisionedEnrollmentTransitionEventEnum!
  ) {
    transitionProvisionedEnrollment(
      input: { enrollmentId: $enrollmentId, transitionEvent: $transitionEvent }
    ) {
      errors
      benefitProvisionedEnrollment {
        id
        state
      }
    }
  }
`

export const useTransitionProvisionedEnrollment = (
  options: InjectedOptions<
    TransitionProvisionedEnrollmentPayload,
    TransitionProvisionedEnrollmentInput
  >,
) =>
  useMutation<TransitionProvisionedEnrollmentPayload, TransitionProvisionedEnrollmentInput>(
    TransitionProvisionedEnrollmentMutation,
    options,
  )
